export const COMPANY_NAME = "NSTERA Technologies";
